import { h } from 'preact'
import Header from '../header'
import AlertComponent from '../ui-components/AlertComponent'
import { Message } from '../ui-components/Message'
import { RawEmailEditor } from '../raw-email-editor/RawEmailEditor'

type Props = {
  content: string,
  alertMessage: string,
  alertMessageType: null | string,
  onSaveChanges: () => void,
  hideAlertMessage: () => void,
  onContentChange: (html: string) => void,
}

export const emailTemplatePreview = (content: string): string => {
  const dummyEmailCampaign = 'Hi <input-variable>username</input-variable>,'
  return content.replace('{content}', dummyEmailCampaign)
}

export const EmailTemplateEdit = ({ content, alertMessageType, alertMessage, onSaveChanges, hideAlertMessage, onContentChange } : Props) => {
  return (
    <div className='email-template'>
      <Header
        title='Customise Email Template'
        hasBreadcrumb
        breadcrumbText='Email Campaigns'
        breadcrumbLink='/email/email-campaigns'
        cancelCallback={() => window.location.assign('/email/email-campaigns')}
        saveCallback={onSaveChanges}
      />
      { alertMessageType && <AlertComponent
        messageType={alertMessageType}
        message={alertMessage}
        sticky
        isVisibleFor={3000}
        onTimeoutEnd={hideAlertMessage}
        onClose={hideAlertMessage}
      /> }
      <Message
        text='Please include these tags in the template: The {content} tag and the {unsubscribeUrl} tag.'
        fullWidth
      />
      <RawEmailEditor
        content={content}
        onContentChange={onContentChange}
        contentForPreview={emailTemplatePreview(content)}
      />
    </div>
  )
}
